import styled, { css } from 'styled-components';
import { generateScales } from '@helpers/generate-media-queries';
import StyledTextArea from '../text-area.styled';

const SmallTextArea = styled(StyledTextArea)`
  ${({ theme }) => {
    const { mobile, desktop } = theme.inputSize.sm;
    return css`
      ${generateScales('border-radius', mobile.borderRadius, desktop.borderRadius, theme)}
      padding: 0.5rem;
      ${generateScales('font-size', mobile.fontSize, desktop.fontSize, theme)}
    `;
  }}
`;

export default SmallTextArea;
